export const PHONE_TYPES = 'PHONE_TYPES';

export function getPhoneTypes(phoneTypes) {
    return {type: PHONE_TYPES, phoneTypes}
}